import useThemeContextualColors, {
  sectionToParent,
} from "../../hooks/use-theme-contextual-colors";
import { tLayout } from "../../translations";
import type { AddressBlockProps } from "./types";
import { useVariablesValues } from "../../lib/variables-context";

export function AddressWeb({
  locale,
  defaultLocale,
  theme,
  section,
}: AddressBlockProps) {
  const t = tLayout(locale, defaultLocale);
  const colors = useThemeContextualColors(theme, sectionToParent(section));
  const { getVariableValue } = useVariablesValues();

  const isPickupPoint = getVariableValue("address.isPickupPoint") === true;

  return (
    <div
      className="flex gap-4 justify-around items-start"
      style={{ marginBottom: "12px", color: colors.text }}
    >
      <div style={{ display: "inline-block" }}>
        <p
          style={{
            fontWeight: "bold",
            marginBottom: "2px",
            marginTop: "0",
            fontSize: "12px",
          }}
        >
          {isPickupPoint
            ? t("deliveryAddress.titlePickup")
            : t("deliveryAddress.title")}
        </p>
        {!isPickupPoint && (
          <p style={{ margin: "0", lineHeight: "1.3", fontSize: "11px" }}>
            {getVariableValue("customer.firstName")}{" "}
            {getVariableValue("customer.lastName")}
          </p>
        )}
        <p style={{ margin: "0", lineHeight: "1.3", fontSize: "11px" }}>
          {getVariableValue("address.address1")}{" "}
          {getVariableValue("address.address2") &&
            `, ${getVariableValue("address.address2")}`}
        </p>
        <p style={{ margin: "0", lineHeight: "1.3", fontSize: "11px" }}>
          {getVariableValue("address.zip")} {getVariableValue("address.city")},{" "}
          {getVariableValue("address.country")}
        </p>
      </div>
      <div style={{ display: "inline-block" }}>
        <p
          style={{
            fontWeight: "bold",
            marginBottom: "2px",
            marginTop: "0",
            fontSize: "12px",
          }}
        >
          {t("deliveryAddress.orderDetails.title")}
        </p>
        <p style={{ margin: "0", lineHeight: "1.3", fontSize: "11px" }}>
          {t("deliveryAddress.orderDetails.trackingNumber")}{" "}
          {getVariableValue("parcel.trackingId") || "N/A"}
        </p>
        <p style={{ margin: "0", lineHeight: "1.3", fontSize: "11px" }}>
          {t("deliveryAddress.orderDetails.orderNumber")}{" "}
          {getVariableValue("parcel.orderNumber") || "N/A"}
        </p>
      </div>
    </div>
  );
}
